import config from "../config";
import ConfluenceMain from "../components/Confluence/ConfluenceMain.vue";
import ExperimentList from "../components/Experiments/ExperimentList.vue";
import DataMain from "../components/Experiments/DataMain.vue";
import Home from "../views/Home.vue";
import ExperimentSetup from "../components/Experiments/ExperimentSetup.vue";
import BuildPlate from "../views/BuildPlate.vue";
import DisplayRequests from "../components/Requests/RequestsList.vue";
import DisplayRuns from "../components/Runs/RunsList.vue";
import DisplaySamples from "../components/Samples/SamplesList.vue";
import ExperimentGroupsMain from "../components/ExperimentGroups/ExperimentGroupsMain.vue";
import FermenterRunSetup from "../components/FermenterRuns/FermenterRunSetup.vue";
import DataQCDashboard from "../components/DataQC/DataQCDashboard.vue";
import AuthAdmin from "../components/Auth/AuthAdmin.vue";
import BackgroundTaskList from "../components/BackgroundTasks/BackgroundTaskList.vue";
import RoleForm from "../components/Auth/RoleForm.vue";
import GroupForm from "../components/Auth/GroupForm.vue";
import MaterialSamplesMain from "@/components/SamplesV2/MaterialSamplesMain.vue";
import MaterialSamplesConfigMain from "@/components/SamplesV2/MaterialSamplesConfigMain.vue";
import OrdersMain from "../components/Orders/OrdersMain.vue";
import Profile from "../components/User/Profile.vue";
import NotFound404 from "../views/404NotFound";
import RegistriesMain from "@/components/Registries/RegistriesMain.vue";
import RegistrySchemaView from "@/components/Registries/RegistrySchemaView.vue";
import RegistryEntriesView from "@/components/Registries/RegistryEntriesView.vue";
import RequestProtocolsConfigMain from "@/components/SamplesV2/RequestProtocolsConfigMain.vue";
import RequestProtocolView from "@/components/SamplesV2/RequestProtocolView.vue";
import RequestsMain from "@/components/SamplesV2/RequestsMain.vue";
import SchemaConfigView from "@/components/SchemaConfig/SchemaConfigView.vue";
import SchemaConfigList from "@/components/SchemaConfig/SchemaConfigList.vue";
import ExperimentMethodsMain from "@/components/ExperimentMethods/ExperimentMethodsMain.vue";
import ExperimentGroupRelationshipConfigList from "@/components/ExperimentRelationshipConfigs/ExperimentGroupRelationshipConfigList.vue";
import SchemaConfigRelationshipConfigList from "@/components/ExperimentRelationshipConfigs/SchemaConfigRelationshipConfigList.vue";
import ExperimentGroupView from "@/components/ExperimentGroups/ExperimentGroupView.vue";
import RequestView from "@/components/SamplesV2/RequestView.vue";

function requiredPermission(permissionString) {
    return {
        permissions: {
            oneOf: [permissionString],
        },
    };
}

export const routes = [
    {
        path: "/",
        name: "Home",
        component: Home,
    },
    {
        path: "/experiments",
        name: "Experiments",
        component: ExperimentList,
        meta: {
            ...requiredPermission("ExperimentData:Read"),
        },
        menu: {
            icon: "$flask-empty-outline",
            text: "Experiments",
            createLink: {
                path: "/setup",
                query: { type: "create" },
                ...requiredPermission("Experiments:Create"),
            },
            spaceAbove: true,
        },
    },
    {
        path: "/experiment/:code/:protocolId?/:date?/:qrCode?",
        name: "ExperimentData",
        component: DataMain,
        props: true,
        meta: {
            ...requiredPermission("ExperimentData:Read"),
        },
    },
    {
        path: "/setup",
        name: "ExperimentSetup",
        component: ExperimentSetup,
        meta: {
            ...requiredPermission("Experiments:Create"),
        },
    },
    {
        path: "/plate/:requestCode?",
        name: "BuildPlate",
        component: BuildPlate,
        meta: {
            permissions: {
                oneOf: ["Requests:Create", "Samples:Create"],
            },
        },
    },
    {
        path: "/requests/:req?",
        name: "DisplayRequests",
        component: DisplayRequests,
        meta: {
            ...requiredPermission("Requests:Read"),
        },
        menu: {
            icon: "$apps-box",
            text: "Requests",
            createLink: {
                path: "/plate",
                query: { type: "request" },
                ...requiredPermission("Requests:Create"),
            },
        },
    },
    {
        path: "/samples/:req?",
        name: "DisplaySamples",
        component: DisplaySamples,
        meta: {
            ...requiredPermission("Samples:Read"),
        },
        menu: {
            icon: "$test-tube",
            text: "Samples",
            createLink: {
                path: "/plate",
                query: { type: "sample" },
                ...requiredPermission("Samples:Create"),
            },
        },
    },
    {
        path: "/requestsV2",
        name: "Requests v2",
        component: RequestsMain,
        meta: {
            ...requiredPermission("MaterialSamples:Read"),
        },
        menu: {
            icon: "$apps-box",
            text: "Requests v2",
        },
    },
    {
        path: "/requestsV2/config",
        name: "RequestsV2Config",
        component: RequestProtocolsConfigMain,
        meta: {
            ...requiredPermission("MaterialSamples:ManageConfig"),
        },
    },
    {
        path: "/requestsV2/:requestCode",
        name: "RequestView",
        component: RequestView,
        meta: {
            ...requiredPermission("MaterialSamples:Read"),
        },
    },
    {
        path: "/requestsV2/config/protocol/:code",
        name: "RequestProtocolView",
        component: RequestProtocolView,
        meta: {
            ...requiredPermission("MaterialSamples:ManageConfig"),
        },
    },
    {
        path: "/samplesV2",
        name: "Samples v2",
        component: MaterialSamplesMain,
        meta: {
            ...requiredPermission("MaterialSamples:Read"),
        },
        menu: {
            icon: "$test-tube",
            text: "Samples v2",
        },
    },
    {
        path: "/samplesV2/config",
        name: "SamplesV2Config",
        component: MaterialSamplesConfigMain,
        meta: {
            ...requiredPermission("MaterialSamples:ManageConfig"),
        },
    },
    {
        path: "/orders",
        name: "Orders",
        component: OrdersMain,
        meta: {
            ...requiredPermission("Orders:Manage"),
        },
        menu: {
            icon: "$cart",
            text: "Orders",
        },
    },
    {
        path: "/runs",
        name: "DisplayRuns",
        component: DisplayRuns,
        meta: {
            ...requiredPermission("Runs:Read"),
        },
        menu: {
            icon: "$view-list",
            text: "LCMS Runs",
            createLink: {
                path: "/runs",
                query: { type: "create" },
                ...requiredPermission("Runs:Create"),
            },
        },
    },
    {
        path: "/protocols/:protocolCode?",
        name: "ViewMangoProtocol",
        component: SchemaConfigView,
        meta: {
            permissions: {
                oneOf: ["Protocols:Create", "Protocols:Update"],
            },
        },
    },
    {
        path: "/schemaConfigs/:schemaConfigCode?",
        name: "ViewSchemaConfig",
        component: SchemaConfigView,
        meta: {
            permissions: {
                oneOf: ["SchemaConfigs:Manage"],
            },
        },
    },
    {
        path: "/experimentMethods/",
        name: "ListExperimentMethods",
        component: ExperimentMethodsMain,
        meta: {
            permissions: {
                oneOf: ["ExperimentMethods:Manage", "ExperimentMethods:Read"],
            },
        },
        menu: {
            icon: "$tools",
            text: "Experiment Methods",
        },
    },
    {
        path: "/schemaConfigs/",
        name: "SchemaConfigList",
        component: SchemaConfigList,
        meta: {
            permissions: {
                oneOf: ["SchemaConfigs:Manage", "SchemaConfigs:Read"],
            },
        },
        menu: {
            icon: "$tools",
            text: "Schema Configs",
        },
    },
    {
        path: "/experiment-groups",
        name: "ExperimentGroups",
        component: ExperimentGroupsMain,
        meta: {
            ...requiredPermission("ExperimentGroups:Read"),
        },
        menu: {
            icon: "$folder",
            text: "Experiment Groups",
        },
    },
    {
        path: "/experiment-groups/:code",
        name: "ExperimentGroupView",
        component: ExperimentGroupView,
        meta: {
            ...requiredPermission("ExperimentGroups:Read"),
        },
    },
    {
        path: "/registries",
        name: "Registries",
        component: RegistriesMain,
        meta: {
            ...requiredPermission("Registries:Read"),
        },
        menu: {
            icon: "$bookshelf",
            text: "Registries",
        },
    },
    {
        path: "/registries/entries/:name",
        name: "RegistryEntriesView",
        component: RegistryEntriesView,
        meta: {
            ...requiredPermission("Registries:Read"),
        },
    },
    {
        path: "/registries/view/:name",
        name: "RegistrySchemaView",
        component: RegistrySchemaView,
        meta: {
            ...requiredPermission("Registries:Read"),
        },
    },
    {
        path: "/protocols/:protocolCode/:thingSchemaName?",
        name: "SchemaConfigViewForProtocol",
        component: SchemaConfigView,
        meta: {
            permissions: {
                oneOf: ["Protocols:Create", "Protocols:Update"],
            },
        },
    },
    {
        path: "/schemaConfigs/:schemaConfigCode/:thingSchemaName?",
        name: "SchemaConfigViewForSchemaConfig",
        component: SchemaConfigView,
        meta: {
            permissions: {
                oneOf: ["SchemaConfigs:Manage"],
            },
        },
    },
    {
        path: "/newFermenterRun",
        name: "Fermenter Runs",
        component: FermenterRunSetup,
        meta: {
            ...requiredPermission("HTPFermenterBatch:Setup"),
        },
        menu: {
            icon: "$bottle-tonic",
            text: "Fermenter Runs",
            visible: !!config.vueAppEnableStrainEngineering,
        },
    },
    {
        path: "/data-qc",
        name: "Data QC",
        component: DataQCDashboard,
        meta: {
            ...requiredPermission("DataQC:Read"),
        },
        menu: {
            icon: "$clipboard-text",
            text: "Data QC",
        },
    },
    {
        path: "/auth/admin",
        name: "AuthAdmin",
        component: AuthAdmin,
        meta: {
            ...requiredPermission("Auth:Manage"),
        },
        menu: {
            icon: "$account-lock",
            text: "Auth",
        },
    },
    {
        path: "/background-tasks",
        name: "BackgroundTasks",
        component: BackgroundTaskList,
        meta: {
            ...requiredPermission("BackgroundTasks:Read"),
        },
        menu: {
            icon: "$cogs",
            text: "Background Tasks",
        },
    },
    {
        path: "/confluence",
        name: "Confluence",
        component: ConfluenceMain,
        meta: {
            ...requiredPermission("Confluence:Create"),
        },
        menu: {
            icon: "$atlassian",
            text: "Confluence",
        },
    },
    {
        path: "/auth/roles/edit/:id?",
        name: "RoleForm",
        component: RoleForm,
        meta: {
            ...requiredPermission("Auth:Manage"),
        },
    },
    {
        path: "/auth/groups/edit/:id?",
        name: "GroupForm",
        component: GroupForm,
        meta: {
            ...requiredPermission("Auth:Manage"),
        },
    },
    {
        path: "/user/profile",
        name: "Profile",
        component: Profile,
    },
    {
        path: "/:pathMatch(.*)",
        name: "NotFound",
        component: NotFound404,
    },
];

export const allMenuItems = routes
    .filter((route) => route.menu)
    .map((route) => {
        return {
            ...route.menu,
            permissions: route.meta.permissions,
            path: route.path,
        };
    });
